var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('content-page',{attrs:{"page":_vm.page,"loading":_vm.loading}}),(!_vm.isAuthed)?_vm._t("footer"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }